import React, { FunctionComponent, useContext } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormActions,
    FormAdditionalValidation,
    FormFields,
    FormTextField,
    FormUploadField,
    getById,
    Stack
} from "sprint-common-web";

import { ManzanitaPresetListingContext } from "../../context/ManzanitaPresetListingContext";
import { validatePresetFile } from "../validation/validatePresetFile";
import { useEditManzanitaPresetForm } from "./useEditManzanitaPresetForm";

export interface EditManzanitaPresetFormProps {
    presetId: string;
    onCancel(): void;
    onSubmit(): void;
}

export interface EditManzanitaPresetFormInputs {
    id: string;
    name: string;
}

export const EditManzanitaPresetForm: FunctionComponent<EditManzanitaPresetFormProps> = (
    props: EditManzanitaPresetFormProps
) => {
    const { items } = useContext(ManzanitaPresetListingContext);

    const itemToEdit = getById(items, props.presetId);

    const { errors, control, formState, reset, handleSubmit } = useForm<EditManzanitaPresetFormInputs>({
        defaultValues: {
            name: itemToEdit.name
        },
        criteriaMode: "all"
    });

    const { editManzanitaPreset, dropFile, clearFile, isFileDropped, formFile } = useEditManzanitaPresetForm(
        itemToEdit.filePath
    );

    const handleEditManzanitaPreset = async ({ name }: EditManzanitaPresetFormInputs) => {
        await editManzanitaPreset({ id: props.presetId, name });
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    const onDropFile = async (presetFile: File) => {
        await dropFile(presetFile);
    };

    const onRemoveFile = () => {
        clearFile();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditManzanitaPreset)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                    <FormUploadField
                        droppedFilePath={formFile?.name}
                        onDropFile={onDropFile}
                        onRemoveFile={onRemoveFile}
                    />
                    <FormActions
                        onCancel={handleCancelButtonClick}
                        submitDisabled={!isFileDropped}
                        isLoading={formState.isSubmitting}
                    />
                    <FormAdditionalValidation
                        control={control}
                        name="additionalValidation"
                        errors={errors}
                        rules={{ validate: () => validatePresetFile(formFile?.name, formFile?.size) }}
                    />
                </FormFields>
            </Stack>
        </Form>
    );
};
